import React from 'react'

import numeral from 'numeral'

import {
  string, array, shape, number, bool, oneOfType,
} from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import MessageFiles from '../../../../Shared/Messaging/Components/MessageFiles'
import MessageImages from '../../../../Shared/Messaging/Components/MessageImages'
import JobInfoRow from '../../Components/JobInfoRow'

function JobDescription({ included = EMPTY_ARRAY, data }) {
  const images = included && included.filter(attachment => attachment.attributes.contentType === 'image')
  const files = included && included.filter(attachment => attachment.attributes.contentType === 'file')
  const { attributes } = data

  function isApplicationCountVisible() {
    if (attributes.isViewerDesigner) {
      return attributes.type === 'public' && ['unapproved', 'approved'].includes(attributes.status)
    }
    return ['unapproved', 'approved'].includes(attributes.status) && ['public', 'private'].includes(attributes.type)
  }

  function renderPriceLabel() {
    if (attributes.status === 'approved') {
      return attributes.isViewerDesigner ? renderPerspective(attributes.availableActions.primary) : 'Budget: '
    }
    return 'Price: '
  }

  function renderPerspective(actions = []) {
    const isYourOffer = actions.filter(action => action === 'counter_offer')
    return isYourOffer.length < 1 ? 'My offer: ' : 'Client\'s offer: '
  }

  return (
    <div className="container-fixed job-page__description">
      <h2 className="heading-24">{attributes.title}</h2>
      <div className="row">
        <div className="col-12 col-md-8">
          <h3 className="section-title">Description</h3>
          <p className="description__content" dangerouslySetInnerHTML={{ __html: attributes.description }} />
          <div className="job-pricing">
            <div className="pricing__item">
              {renderPriceLabel()}
              <span>{numeral(attributes.price).format('$0')}</span>
            </div>
            {attributes.isViewerDesigner && attributes.revenue > 0 && (
              <div className="pricing__item">
                Revenue: <span>{numeral(attributes.revenue).format('$0')}</span>
              </div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-4 job__image">
          <img src={attributes.image.url} alt={attributes.title} />
        </div>
      </div>

      <div className="job-list-item__row job-list-item__row--bottom job-details">
        <JobInfoRow
          type={attributes.type}
          deadline={attributes.deadline || undefined}
          isResellable={attributes.isResellable}
          software={attributes.software}
          status={attributes.status}
          isApplicationCountVisible={isApplicationCountVisible()}
          applicationCount={attributes.applicationCount}
          isViewerDesigner={attributes.isViewerDesigner}
          skills={attributes.skills}
        />
      </div>

      {included.length !== 0
        && (
        <div className="job-attachments">
          <h2 className="section-title">Additional Files</h2>
          <div className="message__attachments row">
            <MessageImages attachments={images} />
            <MessageFiles files={files} />
          </div>
        </div>
        )}
    </div>
  )
}

JobDescription.propTypes = {
  included: array,
  data: shape({
    attributes: shape({
      title: string.isRequired,
      type: string.isRequired,
      description: string.isRequired,
      price: number.isRequired,
      revenue: number.isRequired,
      image: shape({
        url: string.isRequired,
      }).isRequired,
      deadline: oneOfType([
        string,
        number,
      ]),
      isResellable: bool.isRequired,
      software: array.isRequired,
      applicationCount: number,
    }).isRequired,
  }).isRequired,
}

export default JobDescription
